import http from "../../../http-common-super-admin";

class DashboardService {
    getWingioDashboardDetail(data) {
        return http.get("/kids/dashboard", { params: data });
    }
}


export default new DashboardService();